import { render, staticRenderFns } from "./CartItemCount.vue?vue&type=template&id=259d2c81&functional=true&"
import script from "./CartItemCount.vue?vue&type=script&lang=js&"
export * from "./CartItemCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports